import { useState } from "react";

export function usePhotoUpload(setToast) {
  const [photos, setPhotos] = useState([]);

  const addPhoto = (file) => {
    const photo = {
      file,
      preview: URL.createObjectURL(file),
      name: file.name,
    };

    setPhotos((prev) => [...prev, photo]);
  };

  const removePhoto = (index) => {
    setPhotos((prev) => {
      if (prev[index]?.preview) {
        URL.revokeObjectURL(prev[index].preview);
      }

      return prev.filter((_, i) => i !== index);
    });
  };

  const clearPhotos = () => {
    photos.forEach((p) => {
      if (p.preview) URL.revokeObjectURL(p.preview);
    });

    setPhotos([]);
  };

  return {
    photos,
    addPhoto,
    removePhoto,
    clearPhotos,
  };
}